import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import PageHeader from "@core/components/pageHeader";
import FeedbackTypeList from "views/pages/feedbacktype/FeedbackTypeList";
import AddFeedbackType from "views/pages/feedbacktype/AddFeedbackType";
import APICall from "network/APICall";
import EndPoints from "network/Endpoints";
import { useLocation } from "react-router-dom";
import Utility from "@core/helper/utility";
import { useSelector } from "react-redux";
import Loader from "@core/helper/Loader";

const FeedbackType = () => {
  const [openModal, setOpenModal] = useState(false);
  const [type, setType] = useState("");
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [feedbackTypeList, setFeedbackTypeList] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [updateData, setUpdateData] = useState(null);
  const [totalRecord, setTotalRecord] = useState(0);
  const [permission, setPermission] = useState({});
  const [searchText, setSearchText] = useState("");
  const { userData } = useSelector((state) => state.auth);
  const [role, setRole] = useState("");
  const location = useLocation();

  useEffect(() => {
    if (userData.data.user.role === "2") {
      const feedbacktype = Utility.getUserData({
        datastore: userData,
        activePath: location.pathname,
      });
      setPermission(feedbacktype[1]);
    } else {
      setPermission({});
    }
    setRole(userData.data.user.role);
  }, [location.pathname, userData]);

  const handleDeleteModal = (id) => {
    if (id) {
      const payload = { id };
      APICall("delete", payload, EndPoints.deleteFeedbackType)
        .then((response) => {
          const { isError, message } = response.data;
          if (response.status === 200 && !isError) {
            toast.success(message);
            const filter = feedbackTypeList.filter((o) => o.id !== id);
            setFeedbackTypeList(filter);
            fetchFeedbackType();
          }
        })
        .catch((error) => {
          return error;
        });
    }
    setDeleteOpen(!deleteOpen);
  };

  const handleOpen = (type, id) => {
    setOpenModal(!openModal);
    setType(type);
    if (id) {
      const findList = feedbackTypeList.find((o) => o.id === id);
      setUpdateData(findList);
    }
  };

  useEffect(() => {
    fetchFeedbackType();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageSize, pageNumber, searchText]);

  const fetchFeedbackType = () => {
    Loader.isLoading(true);
    const payload = {
      pageNo: pageNumber + 1,
      limit: pageSize,
      searchText: searchText,
    };
    APICall("post", payload, EndPoints.getFeedbackTypeList)
      .then((response) => {
        const { results, totalCount } = response.data.data;
        if (response.status === 200 && results) {
          setFeedbackTypeList(results);
          setTotalRecord(totalCount);
        } else {
          setFeedbackTypeList([]);
        }
      })
      .catch((error) => {
        return error;
      })
      .finally(() => {
        Loader.isLoading(false);
      });
  };

  const submitFeedbackType = () => {
    fetchFeedbackType();
  };

  return (
    <Grid container spacing={4}>
      <PageHeader
        title={
          <Typography variant="body1" sx={{ fontSize: "1.3rem !important" }}>
            Feedback Type
          </Typography>
        }
      />
      {((permission.view && role === "2") || role === "1") && (
        <Grid item xs={12}>
          <FeedbackTypeList
            handleDeleteModal={handleDeleteModal}
            deleteOpen={deleteOpen}
            handleOpen={handleOpen}
            feedbackTypeList={feedbackTypeList}
            pageSize={pageSize}
            setPageSize={setPageSize}
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            totalRecord={totalRecord}
            permission={permission}
            role={role}
            searchText={searchText}
            setSearchText={setSearchText}
          />
        </Grid>
      )}
      <AddFeedbackType
        open={openModal}
        toggle={handleOpen}
        type={type}
        heading={type === "edit" ? "Update Feedback Type" : "Add Feedback Type"}
        onSubmitFeedbackType={submitFeedbackType}
        updateData={updateData}
        permission={permission}
        role={role}
      />
    </Grid>
  );
};

export default FeedbackType;
